import React from "react";
import { Link } from "react-router-dom";
import "../App.css";
const Hero = () => {
  return (
    <>
      <div className="hero-section padding-container">
        <div className="page-wrapper">
          <div className="hero">
            <div className="hero-text">
              <h1>
                EMPOWERING BUSINESSES{" "}
                <span className="orange-text">WITH DIGITAL INNOVATION</span>
              </h1>

              <h2>
                <span className="orange-text">We craft impactful digital experiences through </span>
                <span >
                  modern design, development, and creative solutions.
                </span>
              </h2> <br />
              <p>
                VisionBird Technologies is a full‑service software and creative
                agency delivering tailored solutions in Web Design, Frontend
                Development, UI/UX Design, Graphic Design, and Motion Graphics.
                Our mission is to help businesses grow with clean, intuitive,
                and results‑oriented digital products.{" "}
              </p>
               <br />

              <button className="cta-btn">
                <Link to="/Contact">LETS TALK</Link>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
